
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estimator",
      function () {
        return require("private-next-pages/estimator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estimator"])
      });
    }
  